import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { config } from '@app/core/app-config';
import { UsersFacade } from '@app/shared/+state/users';
import { LoadingState } from '@app/shared/interfaces';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-signup-with-airbnb',
  templateUrl: './signup-with-airbnb.component.html',
  styleUrls: ['./signup-with-airbnb.component.scss'],
})
export class SignupWithAirbnbComponent implements OnInit {
  form: UntypedFormGroup;
  signUpWithAirbnbLoadingState$: Observable<LoadingState>;
  LoadingState = LoadingState;
  config = config;

  constructor(private usersFacade: UsersFacade) { }

  ngOnInit() {
    this.signUpWithAirbnbLoadingState$ = this.usersFacade.signUpWithAirbnbLoadingState$;

    this.form = new UntypedFormGroup({
      agreed_to_tos: new UntypedFormControl(
        {
          value: false,
          disabled: false,
        },
        {
          validators: [Validators.requiredTrue],
        }
      ),
    });
  }

  signUpWithAirbnb() {
    this.usersFacade.signUpWithAirbnb();
  }
}
